import emailjs from '@emailjs/browser';

if (!import.meta.env.VITE_EMAILJS_SERVICE_ID) {
  throw new Error('VITE_EMAILJS_SERVICE_ID is not configured');
}

if (!import.meta.env.VITE_EMAILJS_TEMPLATE_ID) {
  throw new Error('VITE_EMAILJS_TEMPLATE_ID is not configured');
}

if (!import.meta.env.VITE_EMAILJS_PUBLIC_KEY) {
  throw new Error('VITE_EMAILJS_PUBLIC_KEY is not configured');
}

if (!import.meta.env.VITE_EMAILJS_CONFIRMATION_TEMPLATE_ID) {
  throw new Error('VITE_EMAILJS_CONFIRMATION_TEMPLATE_ID is not configured');
}

export const sendContactEmail = async (data: {
  name: string;
  email: string;
  phone: string;
  category: string;
  description: string;
}) => {
  try {
    // Initialize EmailJS with your public key
    emailjs.init(import.meta.env.VITE_EMAILJS_PUBLIC_KEY);

    // Send notification email to admin
    const adminResponse = await emailjs.send(
      import.meta.env.VITE_EMAILJS_SERVICE_ID,
      import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
      {
        from_name: data.name,
        from_email: data.email,
        phone: data.phone,
        category: data.category,
        message: data.description,
      }
    );

    // Send confirmation email to customer
    const customerResponse = await emailjs.send(
      import.meta.env.VITE_EMAILJS_SERVICE_ID,
      import.meta.env.VITE_EMAILJS_CONFIRMATION_TEMPLATE_ID,
      {
        to_name: data.name,
        to_email: data.email,
        category: data.category,
        message: data.description,
      }
    );

    if (adminResponse.status === 200 && customerResponse.status === 200) {
      return { success: true };
    } else {
      throw new Error('Failed to send one or more emails');
    }
  } catch (error) {
    console.error('Error sending email:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to send email',
    };
  }
};